<h1>
  {{'lbl.wait'|translate}}
</h1>

<ion-card class="ion-margin keep-size">
  <ion-card-content>
    <div class="progress-circle-container">
      <circle-progress
        [percent]="progress"
        [showTitle]="progress < max"
        [showUnits]="progress < max"
        [unitsFontSize]="'16'"
        [titleFontSize]="'24'"
        [radius]="90"
        [outerStrokeWidth]="4"
        [innerStrokeWidth]="4"
        [startFromZero]="false"
        [space]="-12"
        [unitsColor]="progressColor"
        [showSubtitle]="false"
        [titleColor]="progressColor"
        [outerStrokeColor]="progressColor"
        [innerStrokeColor]="trackColor"
        [outerStrokeWidth]="12"
        [innerStrokeWidth]="12"
        [animationDuration]="300">
      </circle-progress>

      <ion-icon
        *ngIf="progress >= max"
        class="circle-checkmark xl flip-x"
        name="checkmark-outline">
      </ion-icon>
    </div>
  </ion-card-content>
</ion-card>

<p *ngIf="message && status">{{ (message + '_' + status) | translate }}</p>
